// 引入后进行初始化
import Aegis from 'aegis-web-sdk';
import { EReportModule } from './constants';
export { EReportModule };

/** 环境映射 */
const envMap: Record<string, string> = {
  local: Aegis.environment.local,
  dev: Aegis.environment.development,
  int: Aegis.environment.test,
  prod: Aegis.environment.production,
};

// 脚手架注入的变量
const version = process.env.GIT_HASH;
const environment = process.env.PROJECT_ENV;
// TODO 本地环境是默认不上报,如果测试本地上报则临时改为 true
const isOpenRUM = !process.env.IS_LOCAL;

let aegisInstance: Aegis | null = null;

const init = () => {
  aegisInstance = new Aegis({
    // TODO 填写生成的 id
    id: 'gQ8QXFg0KvDG2d5ml8', // 上报 id
    reportApiSpeed: false, // 接口测速
    pagePerformance: false, // 页面性能
    reportAssetSpeed: false, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    hostUrl: 'https://rumt-zh.com',
    env: envMap?.[environment] || Aegis.environment.others,
    version,
    assetLog: false,
    pvUrl: '',
    beforeReport: (data: any) => {
      // 拦截：retcode 错误,axios主动上报
      if (data.level === Aegis.logType.RET_ERROR) {
        // 拦截：retcode 错误
        return false;
      }
      return data;
    },
    beforeRequest: function (data: any) {
      if (data.logType === 'pv') {
        return false; // 此处会拦截PV上报
      }
      return data;
    },
    api: {
      retCodeHandler(data: any) {
        // data 是string类型，如果需要对象需要手动parse下
        // url 为请求url
        // xhr 响应,可以通过xhr.response拿到完整的后台响应
        try {
          data = JSON.parse(data);
        } catch (e) {}
        return {
          // isErr 如果是 true 的话，会上报一条 retcode 异常的日志。
          isErr: data.code !== 200,
          code: data.code,
        };
      },
    },
  });
};

/* 设置用户信息 */
const setUser = (userId: string) => {
  aegisInstance?.setConfig({
    uin: userId, // 用户唯一 ID（可选）
  });
};
interface IReportBaseConfig {
  /** 模块名 */
  module: EReportModule;
  /** 额外信息(自定义) */
  extra?: Record<string, any>;
  /** 关键词标识(方便代码搜索) */
  keyword: string;
}
/** 基础主动捕获错误 */
const reportBase = (config: IReportBaseConfig, error?: Error, level?: any) => {
  const { module, keyword, extra } = config;

  const newError = error || new Error(level);
  if (newError) {
    newError.message = `[${module}]${keyword}: ${newError.message}`;
  }
  const ext1 = level === Aegis.logType.INFO ? `[${module}]${keyword}` : newError.message || 'unknown error';

  aegisInstance?.report({
    level: level || Aegis.logType.ERROR,
    msg: JSON.stringify(extra || {}, null, 2), // 10k限制
    ext1, // 1024限制
  });
};
/* 用来上报任意类型的日志信息 */
const report = {
  fatal: (config: IReportBaseConfig, error?: Error) => reportBase(config, error, Aegis.logType.ERROR),
  error: (config: IReportBaseConfig, error?: Error) => reportBase(config, error, Aegis.logType.ERROR),
  warning: (config: IReportBaseConfig, error?: Error) => reportBase(config, error, Aegis.logType.EVENT),
  info: (config: IReportBaseConfig) => reportBase(config, undefined, Aegis.logType.INFO),
};

type reportEventParams = Parameters<Aegis['reportEvent']>;

/* 上报自定义事件 */
const reportEvent = (...params: reportEventParams) => {
  aegisInstance?.reportEvent(...params);
};

const rumInfo = {
  init,
  setUser,
  report,
  reportEvent,
};

type TRumInfo = Partial<typeof rumInfo>;

console.log('==>isOpenRUM', isOpenRUM, version, environment);
const rum = isOpenRUM ? rumInfo : ({} as TRumInfo);

export default rum;
